module.exports = function() {
  return new Worker(__webpack_public_path__ + "03842764767fbc735d27.worker.js");
};